import { useCallback, useState } from 'react';
import classNames from 'classnames';
import { Button, Checkbox } from 'antd';
import { prepareHubspotData, sendToAmplitude, sendToHubspot, useFormData } from '../../model';
import s from './index.module.css';

const solutions = [
    'WAF/WAAP',
    'API discovery tools',
    'API schema enforcement',
    'API security testing',
    'Currently evaluating new products',
    'Just learning API security'
];

export const Solutions = () => {
    const { email, nextStep } = useFormData();
    const [answer, setAnswer] = useState<string[]>([]);

    const handleBack = useCallback(() => nextStep('invite'), []);

    const handleNext = useCallback(async () => {
        sendToAmplitude(`WALLARMCOM_AASM_SOLUTIONS_SUBMITTED`, {
            current_security_solutions: answer
        });
        await sendToHubspot(
            prepareHubspotData({
                email,
                current_solutions: answer.join(';')
            })
        );

        nextStep('purpose');
    }, [email, answer]);

    return (
        <>
            <Checkbox.Group onChange={setAnswer}>
                <div className={s.block}>
                    {solutions.map(item => (
                        <div key={item}>
                            <Checkbox
                                value={item}
                                className={classNames(s.item, answer.includes(item) && s.checked)}
                                onClick={() =>
                                    sendToAmplitude(`WALLARMCOM_AASM_SOLUTIONS_LIST`, {
                                        checked: item
                                    })
                                }
                            >
                                <div>{item}</div>
                            </Checkbox>
                        </div>
                    ))}
                </div>
            </Checkbox.Group>

            <div className={s.actions}>
                <Button size='large' onClick={handleBack}>
                    Back
                </Button>
                <Button
                    type='primary'
                    size='large'
                    htmlType='submit'
                    disabled={!answer.length}
                    onClick={handleNext}
                >
                    Next
                </Button>
            </div>
        </>
    );
};
